export const mapaprop = {
    baseURL: 'https://mapaprop.app/api/action/portal-v2',
    // baseURL: 'http://localhost:8080/api/action/portal-v2',
    token:
        // muzo token 2024-09-27 - 365d valid
        'eyJhbGciOiJIUzI1NiJ9.eyJjb3VudHJ5IjoxLCJjbGllbnRJZCI6ImtYNjRwRkhQZEpXM1JqcEZ4aTRDT09MZEk3MFpIZlJBWHJsNk85RUdlOGk0andiWXREIiwiZGF0YSI6IjE1OCIsImlzcyI6Im1hcGFwcm9wIiwiZW1haWxDb250YWN0IjoiY29udGFjdG9AbWFydGlsbGVyb3N1bmlkb3MuY29tIiwibmV0d29yayI6OCwid2Vic2l0ZUlkIjotMSwicG9ydGFsVXJsIjoiaHR0cHM6Ly93d3cubWFydGlsbGVyb3N1bmlkb3MuY29tIiwibmFtZSI6Ik1hcnRpbGxlcm9zVW5pZG9zLmNvbSIsImN1c3RvbWVySWQiOi0xLCJsb2dvIjoicGFydG5lcnMtbXV6by02NC5wbmciLCJzY29wZXMiOlsibmV0d29yay1zdXNjcmlwdGlvbiIsImludGVybmFsLXBvcnRhbCIsInNpdGVtYXAtcG9ydGFsIiwiY29ycyJdLCJleHAiOjE3NTg5OTcxNjgsImlhdCI6MTcyNzQ2MTE2OH0.cl5TE2CncxUe2XEt1pJkmqof0IxBdu_6T0ziA255xJE',
}
export const propertyHitAccess = {
    baseURL: 'https://property-api.mapaprop.com/property/hit',
    token: 'cGFyYSBwcm9wZXJ0eSBhcGkgdGFtYmllbiBuZWNlc2l0YW1vcyB1bmEgY2xhdmUgYmllbiBidWVuYSAyMDIz',
}
export const serverless = {
    baseURL: 'https://api-muzo.mapaprop.com',
}

export const appSettings = {
    appName: 'MartillerosUnidos.com',
    appUrl: 'https://www.martillerosunidos.com',
    appSitemapUrl: 'https://portal-api-sitemap-production.s3.amazonaws.com/',
}
